import { ApiPostData } from '@/lib/interfaces';

export const postData = <T>(obj: T): ApiPostData<T> => ({ data: obj });
